export default __webpack_public_path__ + "static/media/DNo.27-1.4a8624ba.jpg";